<template>
  <Notfound></Notfound>
</template>

<script>
import Notfound from "@/views/parts/Notfound"
export default {
  mounted() {
    document.title = 'Страница не найдена';
  },
  components: {Notfound},
  methods: {
  },
}
</script>

